/* Estilo B: rotacion suave de los mensajes de la barra de anuncio.
   Sin countdown ni urgencia: solo alterna los mensajes con un fundido
   controlado por la clase .is-active (transicion en el CSS de la barra). */
(function () {
  function init() {
    var bars = document.querySelectorAll('.anber-announce[data-rotate]');
    Array.prototype.forEach.call(bars, function (bar) {
      var items = bar.querySelectorAll('.anber-announce__text');
      if (items.length < 2) return;
      var index = 0;
      setInterval(function () {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, 4500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
